import { getMedusaBackendUrl } from "@lib/config"
import { HttpTypes } from "@medusajs/types"

export interface Bundle {
  id: string
  title: string
  items: BundleItem[]
}

export interface BundleItem {
  id: string
  quantity: number
  product: HttpTypes.StoreProduct
}

export interface BundleProduct {
  bundle_product: Bundle
}

export async function getBundleProduct(
  bundleId: string,
  regionId?: string,
  currencyCode?: string
): Promise<Bundle> {
  const baseUrl = getMedusaBackendUrl()
  const params = new URLSearchParams()

  if (regionId) params.set("region_id", regionId)
  if (currencyCode) params.set("currency_code", currencyCode)

  const res = await fetch(
    `${baseUrl}/store/bundle-products/${bundleId}?${params.toString()}`,
    { 
      next: { revalidate: 300 } // Cache for 5 minutes
    }
  )

  if (!res.ok) {
    throw new Error(
      `Failed to fetch bundle: ${res.status} ${res.statusText}`
    )
  }

  const data: BundleProduct = await res.json()
  return data.bundle_product
}

export async function addBundleToCart(
  cartId: string,
  bundleId: string,
  items: Array<{ item_id: string; variant_id: string }>,
  quantity: number = 1
): Promise<HttpTypes.StoreCart> {
  const res = await fetch(`/api/cart/bundles`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      cart_id: cartId,
      bundle_id: bundleId,
      items,
      quantity,
    }),
  })

  if (!res.ok) {
    const error = await res.json().catch(() => ({}))
    throw new Error(
      (error as any)?.message ?? `Failed to add bundle to cart: ${res.status}`
    )
  }

  const { cart } = await res.json()
  return cart
}

export async function removeBundleFromCart(
  cartId: string,
  bundleId: string
): Promise<HttpTypes.StoreCart> {
  const res = await fetch(`/api/cart/bundles/${bundleId}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cart_id: cartId }),
  })

  if (!res.ok) {
    const error = await res.json().catch(() => ({}))
    throw new Error(
      (error as any)?.message ?? `Failed to remove bundle from cart: ${res.status}`
    )
  }

  const { cart } = await res.json()
  return cart
}
